const RESEND_TIMER_IN_SECONDS: number = 30;

export { RESEND_TIMER_IN_SECONDS };
